// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3h4W4","header":"MessagesList_header__1qYNJ","chat":"MessagesList_chat__-duMd"};